import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import ChatSearcher from "./Searcher.ui";
import Contact from "./Contact.ui";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getChatList, setSelectedChat } from "../Infrastructure/Chat.reducer";
import listChats from "../Application/listChats.logic";
import Conversation from "./Conversation.ui";
import { listConversation } from "../Application/listConversation.logic";

import { getMessages, getSelectedChat } from "../Infrastructure/Chat.reducer";

const chatContainer = { 
  width: {xs: "100%", md: "auto"},
  margin: {xs: "0px", md: "2em 5em 2em 6.5em"},
  //border: "1px solid red"
}

const useStyles = makeStyles((theme) => ({
  columns: { 
    padding: "1em",
    margin: 0,
    display: "flex",
    gap: "2em",
    [theme.breakpoints.down("md")]:{
      gap: 0,
      padding: 0,
      paddingBottom: 10
    }
  },
  container: {
    width: "auto",
    background: "white",
    borderRadius: "8px",
    padding: "1em",
    height: "auto",
    [theme.breakpoints.down("lg")]:{
      width: "100%",
      borderRadius: "0px",
      paddingBottom: 30,
      //border: "8px solid green"
    }
  },
  /* conversationContainer: ({isConversationActive}) => ({
    width: "auto",
    background: "white",
    borderRadius: "8px",
    padding: "1em",
    height: "auto",
    [theme.breakpoints.down("md")]:{
      display: isConversationActive ? "block" : "none",
      width: "100%",
      borderRadius: "0px"
    }
  }), */
  contacts: { 
    width: "40%",
    [theme.breakpoints.down("md")]:{
      minHeight: "100vh",
      hight: "auto",
      width: "100%",
      //border: "2px solid aqua",
    },
    [theme.breakpoints.down("lg")]:{
     width: "100%" 
    }
  },
  chat: { 
    width: "60%",
    [theme.breakpoints.down("md")]:{
      minHeight: "100vh",
      hight: "auto",
      paddingBottom: 40,
      width: "100%",
    },
    [theme.breakpoints.down("lg")]:{
      width: "100%" 
     }
  },
  bubbles: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    height: "30em",
  },
}));

export default function Chat() {
  const selectedChat = useSelector(getSelectedChat);
  const { container, contacts, columns, chatContainerSecondary } = useStyles({selectedChat});
  const [searcher, setSearcher] = useState("");
  const [breakpoint, setBreakpoint] = React.useState(window.innerWidth < 1024 ? true : false);
  const dispatch = useDispatch();
  const chatList = useSelector(getChatList);
  const userID = localStorage.getItem("userid");
  const chatID = useParams().id;

  const handleResizeTitle = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 1024) {
      setBreakpoint(true);
    } else if (screenWidth > 1024) {
      setBreakpoint(false);
    }
  };

  useEffect(() => {
    listChats(userID).then((chats) => {
      if (chatID) {
        const [contact] = chats.filter((record) => record.id === chatID);
        listConversation(chatID);
        dispatch(setSelectedChat(contact));
      }
    });
    window.addEventListener("resize", handleResizeTitle);
    window.addEventListener("load", handleResizeTitle);
    return () => {
      window.removeEventListener("resize", handleResizeTitle);
      window.addEventListener("load", handleResizeTitle);
    };
  }, [chatID, dispatch, userID]);


  return (
    <Box sx={chatContainer}>
      <Box className={columns}>
        { (selectedChat && breakpoint) ? <></> : <Box className={[container, contacts]}>
          <ChatSearcher searcher={searcher} setSearcher={setSearcher} />
          {chatList?.map((record) => (
            <Contact
              key={record.id}
              contact={record}
              isSelected={record.id === chatID}
            />
          ))}
        </Box>}
          <Conversation classes={useStyles()}/>
      </Box>
    </Box>
  );
}
